import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useMarketing, MarketingClient } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<MarketingClient>
      useData={useMarketing}
      config={{
        ...moduleConfig,
        defaultTableDensity: 'compact',
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

